import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const styles = () => ({
  field: {
    display: 'flex',
    flexDirection: 'column',
  },
  fieldLine: {
    display: 'flex',
    flexDirection: 'row',
  },
});

const Layout = ({
  classes,
}) => {
  return (
    <Box className={classes.field}>
      <Box className={classes.fieldLine}>
        <MetaControlField
          attr={'fieldName'}
        />
        <MetaControlField
          attr={'value'}
        />
      </Box>
      <Box className={classes.fieldLine}>
        <MetaControlField
          attr={'lastUpdatedAt'}
          hideEmptyFields
        />
        <MetaControlField
          attr={'lastUpdatedBy'}
          hideEmptyFields
        />
      </Box>
    </Box>
  );
};

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
